import { gql } from "@apollo/client";

export const CREATE_GTM_PROJECT = gql`
  mutation CREATE_GTM_PROJECT(
    $name: String!
    $startUpProjectId: ID
    $ownerId: ID
    $packagingBasic: String
  ) {
    createGtmProject(
      name: $name
      startUpProjectId: $startUpProjectId
      ownerId: $ownerId
      packagingBasic: $packagingBasic
    ) {
      gtmProject {
        id
      }
    }
  }
`;
